import React, { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import GlobalStyles from './styles/theme';
import AppRoutes from './routers';
import './styles/style.css';
import './styles/icon_style.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'userData' && e.oldValue && !e.newValue && window.location.pathname !== '/') {
        window.location.href = '/';
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <ThemeProvider theme={GlobalStyles}>
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <CssBaseline>
          <AppRoutes />
        </CssBaseline>
      </div>
    </ThemeProvider>
  );
}

export default App;
